import { options as n } from "preact";
var t,
    u,
    r,
    o,
    i = 0,
    c = [],
    f = [],
    e = n.__b,
    a = n.__r,
    v = n.diffed,
    l = n.__c,
    m = n.unmount;

function p(t, r) {
  n.__h && n.__h(u, t, i || r), i = 0;
  var o = u.__H || (u.__H = {
    __: [],
    __h: []
  });
  return t >= o.__.length && o.__.push({
    __V: f
  }), o.__[t];
}

function y(n) {
  return i = 1, d(z, n);
}

function d(n, r, o) {
  var i = p(t++, 2);
  return i.t = n, i.__c || (i.__ = [o ? o(r) : z(void 0, r), function (n) {
    var t = i.t(i.__[0], n);
    i.__[0] !== t && (i.__ = [t, i.__[1]], i.__c.setState({}));
  }], i.__c = u), i.__;
}

function _(r, o) {
  var i = p(t++, 3);
  !n.__s && w(i.__H, o) && (i.__ = r, i.u = o, u.__H.__h.push(i));
}

function h(r, o) {
  var i = p(t++, 4);
  !n.__s && w(i.__H, o) && (i.__ = r, i.u = o, u.__h.push(i));
}

function s(n) {
  return i = 5, F(function () {
    return {
      current: n
    };
  }, []);
}

function A(n, t, u) {
  i = 6, h(function () {
    return "function" == typeof n ? (n(t()), function () {
      return n(null);
    }) : n ? (n.current = t(), function () {
      return n.current = null;
    }) : void 0;
  }, null == u ? u : u.concat(n));
}

function F(n, u) {
  var r = p(t++, 7);
  return w(r.__H, u) ? (r.__V = n(), r.u = u, r.__h = n, r.__V) : r.__;
}

function T(n, t) {
  return i = 8, F(function () {
    return n;
  }, t);
}

function q(n) {
  var r = u.context[n.__c],
      o = p(t++, 9);
  return o.c = n, r ? (null == o.__ && (o.__ = !0, r.sub(u)), r.props.value) : n.__;
}

function x(t, u) {
  n.useDebugValue && n.useDebugValue(u ? u(t) : t);
}

function V(n) {
  var r = p(t++, 10),
      o = y();
  return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function (n) {
    r.__ && r.__(n), o[1](n);
  }), [o[0], function () {
    o[1](void 0);
  }];
}

function b() {
  for (var t; t = c.shift();) {
    if (t.__P) try {
      t.__H.__h.forEach(j), t.__H.__h.forEach(k), t.__H.__h = [];
    } catch (u) {
      t.__H.__h = [], n.__e(u, t.__v);
    }
  }
}

n.__b = function (n) {
  u = null, e && e(n);
}, n.__r = function (n) {
  a && a(n), t = 0;
  var o = (u = n.__c).__H;
  o && (r === u ? (o.__h = [], u.__h = [], o.__.forEach(function (n) {
    n.__V = f, n.u = void 0;
  })) : (o.__h.forEach(j), o.__h.forEach(k), o.__h = [])), r = u;
}, n.diffed = function (t) {
  v && v(t);
  var i = t.__c;
  i && i.__H && (i.__H.__h.length && (1 !== c.push(i) && o === n.requestAnimationFrame || ((o = n.requestAnimationFrame) || function (n) {
    var t,
        u = function u() {
      clearTimeout(r), g && cancelAnimationFrame(t), setTimeout(n);
    },
        r = setTimeout(u, 100);

    g && (t = requestAnimationFrame(u));
  })(b)), i.__H.__.forEach(function (n) {
    n.u && (n.__H = n.u), n.__V !== f && (n.__ = n.__V), n.u = void 0, n.__V = f;
  })), r = u = null;
}, n.__c = function (t, u) {
  u.some(function (t) {
    try {
      t.__h.forEach(j), t.__h = t.__h.filter(function (n) {
        return !n.__ || k(n);
      });
    } catch (r) {
      u.some(function (n) {
        n.__h && (n.__h = []);
      }), u = [], n.__e(r, t.__v);
    }
  }), l && l(t, u);
}, n.unmount = function (t) {
  m && m(t);
  var u,
      r = t.__c;
  r && r.__H && (r.__H.__.forEach(function (n) {
    try {
      j(n);
    } catch (n) {
      u = n;
    }
  }), u && n.__e(u, r.__v));
};
var g = "function" == typeof requestAnimationFrame;

function j(n) {
  var t = u,
      r = n.__c;
  "function" == typeof r && (n.__c = void 0, r()), u = t;
}

function k(n) {
  var t = u;
  n.__c = n.__(), u = t;
}

function w(n, t) {
  return !n || n.length !== t.length || t.some(function (t, u) {
    return t !== n[u];
  });
}

function z(n, t) {
  return "function" == typeof t ? t(n) : t;
}

export { y as useState, d as useReducer, _ as useEffect, h as useLayoutEffect, s as useRef, A as useImperativeHandle, F as useMemo, T as useCallback, q as useContext, x as useDebugValue, V as useErrorBoundary };